export default __webpack_public_path__ + "static/media/void.fe0b33f2.svg";